import * as React from "react";
import Layouts from "../../components/Layouts";
import { Row, Col, Card, Button } from "antd";
import HomeInsurancePolicy from "../../components/grid/HomeInsurancePolicy";
class Addpolicy extends React.Component {
  render() {
    return (
      <Layouts title="assets" classname="grid">
        <Row gutter={16}>
          <Col xs={24} lg={24}>
            <Card bordered={false} bodyStyle={{ padding: "0 20px 20px" }}>
              <HomeInsurancePolicy />
            </Card>
          </Col>
        </Row>
      </Layouts>
    );
  }
}

export default Addpolicy;
